import React from 'react';
import { TableBody, TableCell, Paper, makeStyles } from '@material-ui/core';

import { StyledTable, TableHeadStyled, TableRowStyled } from './style';

import { LoadingIndicator } from 'components/IoseLoader';
import { IoseInfinityScroll } from 'components/IoseInfinityScroll';

import IoseNoDataMessage from 'components/IoseNoDataMessage';

const useStyles = makeStyles(() => ({
  tableHeaderCell: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    color: '#fff',
  },
  tableCell: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
  },
}));

const TableCellCentered = ({ children }) => {
  const classes = useStyles();

  return <TableCell className={classes.tableCell}>{children}</TableCell>;
};

const TableHeaderCellCentered = ({ children }) => {
  const classes = useStyles();

  return <TableCell className={classes.tableHeaderCell}>{children}</TableCell>;
};

const CircuitsTableRow = ({ value, onClick }) => {
  const classes = useStyles();
  return (
    <TableRowStyled align="center" className={classes.tableRow}>
      <TableCellCentered>
        {parseFloat(value?.tarifa).toLocaleString('pt-BR', {
          minimumFractionDigits: 4,
        })}
      </TableCellCentered>
      <TableCellCentered>{value?.month}</TableCellCentered>
      <TableCellCentered> {value?.year}</TableCellCentered>
      <TableCellCentered>
        {parseFloat(value?.yearTariff).toLocaleString('pt-BR', {
          minimumFractionDigits: 4,
        })}
      </TableCellCentered>

      {/* <TableCellCentered>
        <a href={value.file_link} download>
          <ContractsIcon />
        </a>
      </TableCellCentered> */}
    </TableRowStyled>
  );
};

const CircuitsTable = ({ data, onRowClick }) => (
  <StyledTable>
    <TableHeadStyled>
      <TableRowStyled align="center">
        <TableHeaderCellCentered>TARIFA MENSAL</TableHeaderCellCentered>
        <TableHeaderCellCentered>MÊS</TableHeaderCellCentered>
        <TableHeaderCellCentered>ANO</TableHeaderCellCentered>
        <TableHeaderCellCentered>TARIFA ANUAL</TableHeaderCellCentered>
      </TableRowStyled>
    </TableHeadStyled>

    <TableBody>
      {data?.map((value, index) => (
        <CircuitsTableRow key={index} value={value} onClick={onRowClick} />
      ))}
    </TableBody>
  </StyledTable>
);

export default function IoseCarbonTariffsTable({ loading, data }) {
  // Função para ordenar os dados
  const sortDataByYearAndMonth = (data) => {
    return data.sort((a, b) => {
      // Ordena primeiro por ano
      if (a.year !== b.year) {
        return parseInt(a.year) - parseInt(b.year);
      }
      // Se o ano for o mesmo, ordena por mês
      return parseInt(a.month) - parseInt(b.month);
    });
  };

  // Renderiza a tabela ou mensagem de erro
  function renderChartOrErrorMessage() {
    if (data && data.length > 0) {
      // Ordena os dados antes de renderizar
      const sortedData = sortDataByYearAndMonth(data);

      console.log('sortedData: ', sortedData);

      return (
        <Paper>
          <CircuitsTable data={sortedData} id="scrollableDiv" />
        </Paper>
      );
    } else {
      return (
        <IoseNoDataMessage
          message="Ops... Parece que não há dados suficientes para exibir a tabela!"
          height="300px"
          width="300px"
        />
      );
    }
  }
  return (
    <div>
      {loading ? (
        <LoadingIndicator loading={loading} />
      ) : (
        <IoseInfinityScroll
          dataLength={data ? parseInt(data.length) : 7}
          next={() => {}}
          hasMore={false}
          loading={false}
          endList={false}
          sidebar={false}
          marginTop={'0'}
          padding={'0'}
          colortextend={null}
          sizetextend={null}
          scrollableTarget="scrollableDiv"
          height={600}
        >
          {renderChartOrErrorMessage()}
        </IoseInfinityScroll>
      )}
    </div>
  );
}
